import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { ProvisionSpecStatusEnum } from "../../data/enums";

export namespace ProvisionValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            priority: baseVals.intRange(1, 10, "Prioritas"),
            specs: v.pipe(
                v.array(
                    v.object({
                        name: baseVals.string(),
                        status: v.picklist(ProvisionSpecStatusEnum.values),
                        quantity: baseVals.intMin(1, "Jumlah"),
                        notes: v.optional(baseVals.string()),
                    }),
                ),
                v.minLength(1, `Daftar Kebutuhan Barang tidak boleh kosong`),
            ),
            warehouseId: baseVals.string(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            priority: v.exactOptional(baseVals.intRange(1, 10, "Prioritas")),
            specs: v.exactOptional(
                v.pipe(
                    v.array(
                        v.object({
                            name: baseVals.string(),
                            status: v.picklist(ProvisionSpecStatusEnum.values),
                            quantity: baseVals.intMin(1, "Jumlah"),
                            notes: v.optional(baseVals.string()),
                        }),
                    ),
                    v.minLength(1, `Daftar Kebutuhan Barang tidak boleh kosong`),
                ),
            ),
        }),
    );

    export const CreateTaken = defineValidation(
        v.object({
            specId: baseVals.string(),
            items: v.array(
                v.object({
                    itemId: baseVals.string(),
                    quantity: baseVals.intMin(1, "Jumlah"),
                }),
            ),
        }),
    );

    export const CancelTaken = defineValidation(
        v.object({
            specId: baseVals.string(),
        }),
    );

    export const UpdateComplete = defineValidation(
        v.object({
            receiverId: baseVals.string(),
        }),
    );
}
